import React from "react";
import PropTypes from "prop-types";

import {
  questionTypeConstants,
  EMPTY_ARRAY_LENGTH,
} from "../../../../constants";
import Textbox from "../textbox";
import CustomerStarRanking from "../customerStarRanking";
import UnsupportedQuestionType from "./unsupportedQuestionType";

/**
 * Renders the active customer/preview survey question by type.
 * Falls back to UnsupportedQuestionType when type is missing or unknown.
 */
const SurveyQuestionRenderer = ({
  question,
  currentQuestion,
  questionArray,
  ...questionProps
}) => {
  if (
    !question ||
    !Array.isArray(questionArray) ||
    questionArray.length === EMPTY_ARRAY_LENGTH
  ) {
    return <UnsupportedQuestionType />;
  }

  const questionTypeId = Number(question.questionTypeId);

  if (questionTypeId === questionTypeConstants.STAR_RANKING_ID) {
    return (
      <CustomerStarRanking
        key={question.questionOrder}
        question={question}
        currentQuestion={currentQuestion}
        questionArray={questionArray}
        {...questionProps}
      />
    );
  }

  if (questionTypeId === questionTypeConstants.TEXTBOX_ID) {
    return (
      <Textbox
        key={question.questionOrder}
        question={question}
        currentQuestion={currentQuestion}
        questionArray={questionArray}
        {...questionProps}
      />
    );
  }

  return <UnsupportedQuestionType />;
};

SurveyQuestionRenderer.propTypes = {
  question: PropTypes.object,
  currentQuestion: PropTypes.number,
  questionArray: PropTypes.array,
};

export default SurveyQuestionRenderer;
